import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { I18nModule } from '@spartacus/core';
import { ItemCounterComponent } from './item-counter.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    I18nModule,
    FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
    ItemCounterComponent,
  ],
  exports: [ItemCounterComponent],
})
export class ItemCounterModule {}
